import React from "react";
import { Card, Statistic } from "antd";
import { DollarOutlined } from "@ant-design/icons";

const AvgOrderValueCard = ({ value = 0 }) => {
  return (
    <Card className="dashboard-card">
      <div className="">
        <div className="d-flex align-items-center justify-content-between">
          <h5 className="card-title">AVG ORDER VALUE</h5>
          <div className="icon-box purple">
            <DollarOutlined />
          </div>
        </div>
        
        <Statistic
          value={value}
          precision={2}
          prefix="$"
          valueStyle={{ color: "#3f8600", fontWeight: "bold", fontSize: "24PX" }}
        />
      </div>
    </Card>
  );
};

export default AvgOrderValueCard;
